<script setup>
import { onMounted } from "vue";
import { useGlobalStore } from "@stores/global.js";

const props = defineProps({
	images: {
		type: Array,
		default: () => [
			"https://images.unsplash.com/photo-1625982503303-5a3e849260a7?q=80&w=3118&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
			"https://images.unsplash.com/photo-1625982503303-5a3e849260a7?q=80&w=3118&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
		],
	},
	className: {
		type: String,
		default: "",
	},
});

const global = useGlobalStore();

onMounted(() => {
	global.setTheme(null, null, null);
});
</script>

<template>
	<section :class="['py-40 lg:py-80', className]">
		<div class="container">
			<div class="grid gap-8 lg:grid-cols-2">
				<img
					v-for="(image, index) in images"
					:key="index"
					class="aspect-video w-full rounded-lg object-cover"
					:src="image"
					:alt="`Image ${index + 1}`"
				/>
			</div>
		</div>
	</section>
</template>
